module.exports = __webpack_public_path__ + "static/media/skill_roll.dab9c94b.png";